import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=89245010&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=js&"
export * from "./Calls.vue?vue&type=script&lang=js&"
import style0 from "./Calls.vue?vue&type=style&index=0&id=89245010&scoped=true&lang=css&"
import style1 from "@/styles/templateTable.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89245010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VListItem,VListItemTitle,VMenu,VSnackbar,VTextField})
